import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import Logo from "../../assets/images/Logo.png";
import { useNavigate } from "react-router-dom";
import { InfluencerCodeSend, Influencerlogin, login } from "../api/api";
import OneSignal from "react-onesignal";
import "../InfluencerPage/InfluencerResetPasswordPage.css";
import bgImage from "../../assets/images/brown-background.jpg";
import { v4 as uuidv4 } from "uuid";

const InfluencerResetPasswordPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  // const [deviceToken, setDeviceToken] = useState("");
  // const [jwtsToken, setjwtsToken] = useState("");

  useEffect(() => {
    const generatedToken = uuidv4().replace(/-/g, "").substring(0, 32);
    console.log("Generated Token:", generatedToken);
    // setjwtsToken(generatedToken);
    localStorage.setItem("jwtToken", generatedToken);
  }, []);

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
  });

  const showAlert = (message, callback) => {
    Swal.fire({
      title: "",
      text: message,
      icon: "success",
      confirmButtonText: "OK",
    }).then(() => {
      if (callback) callback();
    });
  };
  const showErrorAlert = (message, callback) => {
    Swal.fire({
      title: "Failed",
      text: message,
      icon: "error",
      confirmButtonText: "OK",
    }).then(() => {
      if (callback) callback();
    });
  };

  const handleSubmit = async (values) => {
    console.log("values-in-login0", values);
    try {
      setIsLoading(true);
      const response = await InfluencerCodeSend(values);
      if (response?.success) {
        localStorage.setItem("influencerData", JSON.stringify(response?.data));
        showAlert(response?.message, () =>
          navigate("/InflucerEnterCode", {
            state: { email: values.email },
          })
        );
      } else {
        showErrorAlert(response?.message);
      }
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  //   const handleSubmit = async (values) => {
  //   navigate("/InflucerEnterCode", {
  //     state: { email: values.email },
  //   });
  // };
  return (
    <div
      className="ResetInlogin-box"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Formik
        initialValues={{
          email: "",
          // jwt: jwtsToken,
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ isSubmitting }) => (
          <Form className="ResetInlogin-form">
            <img src={Logo} alt="Logo" className="ResetInlogin-logo" />
            <h1 className="ResetInlogin-heading">Affiliate Email</h1>
            <div className="ResetInloginform-group">
              <label>Email</label>
              <Field
                type="email"
                name="email"
                className="ResetInform-input"
              // placeholder="Enter your email"
              />
              <ErrorMessage
                name="email"
                component="div"
                className="ResetInerror-message"
              />
            </div>
            <button
              type="submit"
              className="ResetInlogin-button"
              disabled={isSubmitting || isLoading}
            >
              {isLoading ? "Sendig OTP..." : "Send OTP"}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default InfluencerResetPasswordPage;
